import lang from '../../../../../../../lib/language';

import { useIsMobile } from '../../../../../../../hooks';
import { UserPhoto } from '../../../../../../index';

import styles from './PersonalNameDetails.module.scss';

type Props = {
    firstName: string;
    middleName: string;
    lastName: string;
}

const PersonalNameDetails = ({ firstName, middleName, lastName }: Props) => {
  const { isMobile } = useIsMobile();

const nameDetails = {
  [lang.commonOnboardingPersonalDetailsFirstName()]: firstName,
  ...(middleName && {
    [lang.commonMiddleName()]: middleName,
  }),
  [lang.commonOnboardingPersonalDetailsLastName()]: lastName,
};

  return (
    <div className={styles.wrapperNameDetails}>
      {isMobile && (
        <div className={styles.detailsHeader}>
          <div>{lang.commonNames()}</div>
        </div>
      )}
      <div className={styles.containerDetails}>
        <div className={styles.cardDetails}>
          {!isMobile && (
            <div className={styles.photo}>
              <UserPhoto first_name={firstName} last_name={lastName} isHeader fullSize />
            </div>
          )}
          {Object.entries(nameDetails).map(([key, value]) => (
            <div className={styles.cardContent} key={key}>
              <div className={styles.cardKey}>{key}</div>
              <div className={styles.nameDetailsCardValue}>
                <div className={styles.valueWrapper}>{value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PersonalNameDetails;
